import React, { FormEvent, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import {
  AppState,
  CheckContentProviderIdExist,
  getKey,
} from "../../services/app.service";
import Actions from "../../redux/actions";
import constants from "../../utils/constants";
import { remoteConfig } from "../../services/firebase.service";
import Languages from "../Languages";
import NotifyAlert from "../NotifyAlert";
import { Link } from "react-router-dom";
import { RouteEndpoints } from "../../services/route.service";
import OAuth from "../../pages/auth/OAuth";

interface props {
  open: boolean;
  hideModal: () => void;
}

const disableCaptcha =
  process.env.REACT_APP_ALLOW_CAPTCHA &&
  process.env.REACT_APP_ALLOW_CAPTCHA === "false";

const SignInModal = ({ open, hideModal }: props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState(disableCaptcha ? "no" : "");
  const [retries, setRetries] = useState(3);
  const dispatch = useDispatch();
  const { state, message } = useSelector(
    (state: IRootState) => state.auth.signIn
  );
  const { recaptchaSiteKey } = useSelector(
    (state: IRootState) => state.setting.keys
  );

  const [showPassword, setShowPassword] = useState(false);
  const [loadCaptcha, setLoadCaptcha] = useState(-3);

  const recaptchaSiteKey1 =
    remoteConfig.getValue(getKey(constants.RECAPTCHA_SITE_KEY)).asString() ??
    "";

  useEffect(() => {
    if (!recaptchaSiteKey && recaptchaSiteKey1) {
      dispatch(Actions.setting.setRecaptchaSiteKey(recaptchaSiteKey1));
    }
  }, [recaptchaSiteKey1]);

  useEffect(() => {
    try {
      loadRC();
    } catch (e) {
      // console.error("captcha", e);
      setLoadCaptcha(loadCaptcha + 1);
    }
  }, [recaptchaSiteKey, loadCaptcha]);

  useEffect(() => {
    if (state === AppState.RETRY && retries > 0) {
      setRetries((prevState) => prevState - 1);
      dispatch(Actions.auth.signIn({ username, password, token }));
    }
  }, [state]);

  const loadRC = () => {
    if (loadCaptcha < 0 && recaptchaSiteKey.length > 0 && !disableCaptcha) {
      // @ts-ignore
      loadReCaptcha(recaptchaSiteKey, () => {
        setLoadCaptcha(1);
      });
    }
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    loadRC();
    e.preventDefault();
    dispatch(
      Actions.auth.signIn({ username, password, token: token ?? "yes" })
    );
  };

  return (
    <>
      {" "}
      <Modal centered show={open} onHide={hideModal}>
        <Modal.Header closeButton />
        <Modal.Body className="text-center">
          <div className="sign-in-from*">
            {/*<h1 className="mb-0">*/}
            {/*  <Languages langKey="signIn" />*/}
            {/*</h1>*/}

            {(state === AppState.ERROR || state === AppState.ERROR_INPUT) && (
              <NotifyAlert
                message={message}
                state={AppState.ERROR}
                timer={10000}
              />
            )}
            {/*<Form className="mt-4" onSubmit={handleSubmit}>*/}
              <div className="sign-info d-flex flex-column">
                <span className="dark-color d-inline-block line-height-2">
                  <Languages langKey="noAccount" />?
                  <Link to={RouteEndpoints.SIGN_UP}>
                    {" "}
                    <Languages langKey="signUp" />
                  </Link>
                </span>

                {!CheckContentProviderIdExist() && <OAuth />}
              </div>
            {/*</Form>*/}
          </div>
        </Modal.Body>
      </Modal>{" "}
    </>
  );
};

export default SignInModal;
